import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {SelectFilterElement} from '../../../../../../../components/common/select-filter/select-filter.model';
import {BehaviorSubject, Subscription} from 'rxjs';
import {FormDefinitionFieldFindAllCachedService} from '../../../impl/service/formDefinitionFieldFindAllCached.service';
import {FormDefinitionFieldSummaryModel} from "../../entity/formDefinitionFieldSummary.model";
import {AuthService} from "../../../../../../auth/api/service/auth.service";

@Component({
    selector: 'app-form-definition-field-select-filter',
    templateUrl: './form-definition-field-select-filter.component.html',
})
export class FormDefinitionFieldSelectFilterComponent implements OnChanges, OnInit{

    @Input() attributeValue: 'id' | 'name';
    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    @Input() errorsMessages: {[key: string]: string};
    @Input() contextValue: string;
    @Input() onlyActive = true;
    @Input() labelId: number;
    @Input() computed: boolean;
    @Input() nbMaxResults = 0;
    @Input() currentAccount: boolean;
    // @Input() newItemModalOptions: NewItemModalOptions<number>;

    @Output() changeEvent: EventEmitter<FormDefinitionFieldSummaryModel> = new EventEmitter<FormDefinitionFieldSummaryModel>();
    elements: BehaviorSubject<SelectFilterElement<string|number, FormDefinitionFieldSummaryModel>[]> =
        new BehaviorSubject<SelectFilterElement<number, FormDefinitionFieldSummaryModel>[]>([]);

    loading = false;
    subscription: Subscription;
    subscriptions: Subscription[] = [];


    constructor(public service: FormDefinitionFieldFindAllCachedService,
                private authService: AuthService) {
        this.subscriptions.push(this.service.loading$.subscribe(value1 => this.loading = value1));
    }

    ngOnInit(): void {
        this.service.findAll();
    }



    ngOnChanges(changes: SimpleChanges) {
        if (changes['contextValue'] || changes['currentAccount'] || changes['computed'] || changes['labelId']) {
            this.subscription?.unsubscribe();
            this.subscription = this.service.entities$.subscribe(values => {
                console.log(['fields', values, this.computed, this.onlyActive, this.contextValue, this.labelId]);
                const fields = values.filter(value => {
                    // console.log(['value', value]);
                    return value.context.value === this.contextValue;
                })
                    .filter(value => this.onlyActive === false || value.active === true)
                    .filter(value => this.computed === undefined || value.computed === this.computed)
                    .filter(value => this.labelId === undefined || value.labelId === this.labelId)
                    .filter(value => !this.currentAccount || value.accountId === this.authService.accountSnapshot?.summary?.id);
                if (this.nbMaxResults > 0 && fields.length > this.nbMaxResults){
                    // fields = fields.slice(0, 10);
                }
                this.elements.next(fields?.map(field => {
                    const value = this.attributeValue === 'name' ? field.name : field.id;
                    return new SelectFilterElement<number|string, FormDefinitionFieldSummaryModel>(value, value, field);
                }));
            });
        }
    }


    filter = (criteria: string, entity: FormDefinitionFieldSummaryModel) => {
        return (entity.label).toUpperCase().indexOf(criteria.toUpperCase()) > -1;
    }

    resolveSelectFilterElement =
        (entity: FormDefinitionFieldSummaryModel): SelectFilterElement<number, FormDefinitionFieldSummaryModel> => {
        return new SelectFilterElement(entity.id, entity.id, entity);
    }

    onChange(element: SelectFilterElement<number, FormDefinitionFieldSummaryModel>){
        this.changeEvent?.emit(element.element);
    }
}
